import { getBackendAPIClient } from "@lib/backendAPIClient";
import { trackingContract } from "@common/contracts/tracking.contract";
import { AnalyticsEvent } from "@common/constants/analytics-events";

const trackingContractClient = getBackendAPIClient(trackingContract);

export async function trackEvent(
    name: AnalyticsEvent,
    properties: Record<string, unknown> = {},
) {
    await trackingContractClient.trackEvent({
        body: { name, properties },
    });
}
